import { action } from 'typesafe-actions';
import { OrdemCargaPageTypes, IOrdemCargaPage, IFiltroOrdemCarga, Pagination } from './types';

export const loadRequest = (
  filtro: IFiltroOrdemCarga | undefined,
  parceiros: number[],
  codCdd: number,
  pagination?: Pagination,
  sorter?: any
) => action(OrdemCargaPageTypes.LOAD_REQUEST, { filtro, parceiros, codCdd, pagination, sorter });
export const loadSuccess = (data: IOrdemCargaPage[], pagination: Pagination) =>
  action(OrdemCargaPageTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(OrdemCargaPageTypes.LOAD_FAILURE);

export const filterOdemCargaPage = (filter: IFiltroOrdemCarga) =>
  action(OrdemCargaPageTypes.FILTER_ORDEMCARGAPAGE, { filter });

export const sorterOrdemCargaPage = (ordenacao: any) =>
  action(OrdemCargaPageTypes.SORTER_ORDEMCARGAPAGE, { ordenacao });

export const cleanStatateOrdemCaragaPage = () => action(OrdemCargaPageTypes.CLEAN_ORDEMCARGAPAGE);
